import React from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Card from "../components/Card";

const HelpCenter = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-[var(--bg-main)]">
      <Sidebar />
      <div className="flex-1 p-4 md:p-8 md:ml-64">
        <div className="mb-6">
          <button
            onClick={() => navigate("/settings")}
            className="mb-4 px-4 py-2 rounded-lg bg-surface-soft text-[var(--text-primary)] hover:bg-surface-soft transition-all"
          >
            Back to Settings
          </button>
          <h1 className="text-3xl md:text-4xl font-bold mb-2 bg-gradient-to-r from-[#22c55e] to-[#16a34a] bg-clip-text text-transparent">
            Help Center
          </h1>
          <p className="text-[var(--text-primary)] text-sm md:text-base">
            Find quick answers to common account and wallet questions.
          </p>
        </div>

        <Card>
          <div className="space-y-4 text-[var(--text-primary)]">
            <div>
              <h3 className="font-semibold mb-1">Account Access</h3>
              <p className="text-sm opacity-80">
                Use the forgot-password flow from login to reset access
                securely.
              </p>
            </div>
            <div>
              <h3 className="font-semibold mb-1">2FA Setup</h3>
              <p className="text-sm opacity-80">
                Go to Profile & Security and enable two-factor authentication
                for stronger account protection.
              </p>
            </div>
            <div>
              <h3 className="font-semibold mb-1">Withdrawals</h3>
              <p className="text-sm opacity-80">
                Verify destination address, network type, and balance before
                requesting a withdrawal.
              </p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default HelpCenter;
